import { Directive, ChangeDetectorRef, Input, SimpleChanges } from '@angular/core';
import { Product } from '@df/catalog/product/product';
import { PriceComponentDef } from '@df/ui/price/price.component.def';
import { CustomerModel } from '@df/session/api/customer.model';

@Directive()
export abstract class ProductPriceComponentDef extends PriceComponentDef {
    @Input()
    product?: Product;

    @Input()
    orgPrice?: boolean;

    constructor(
        ref: ChangeDetectorRef,
        protected customerModel: CustomerModel
    ) {
        super(ref);
    }

    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(this.customerModel.obs.status.subscribe(() => this.update()));
    }

    override ngOnChanges(changesObj: SimpleChanges) {
        super.ngOnChanges(changesObj);
        if (changesObj['product']) {
            this.update();
        }
    }

    protected update(): void {
        this.value = this.product ? (this.orgPrice ? this.product.orgPrice : this.product.price) : undefined;
        this.detectChanges();
    }
}
